import React, { useState, useEffect } from 'react';
import axios from 'axios';
import OrderDetails from './OrderDetails';

const API_URL = '/api';

const OrdersList = ({ onRefresh }) => {
  const [allOrders, setAllOrders] = useState([]);
  const [displayOrders, setDisplayOrders] = useState([]);
  const [counterparties, setCounterparties] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [cars, setCars] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  
  // Фильтры
  const [filterDateFrom, setFilterDateFrom] = useState('');
  const [filterDateTo, setFilterDateTo] = useState('');
  const [filterCounterparty, setFilterCounterparty] = useState('');
  const [filterCar, setFilterCar] = useState('');
  const [filterDriver, setFilterDriver] = useState('');

  // Загрузка данных при старте
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const [ordersRes, cpRes, rRes, cRes, dRes] = await Promise.all([
        axios.get(`${API_URL}/orders`),
        axios.get(`${API_URL}/counterparties`),
        axios.get(`${API_URL}/routes`),
        axios.get(`${API_URL}/cars`),
        axios.get(`${API_URL}/drivers`)
      ]);
      
      const orders = ordersRes.data || [];
      console.log('✅ Загружено заявок:', orders.length);
      console.log('Даты заявок:', orders.map(o => ({ id: o.id, date: o.order_date })));
      
      setAllOrders(orders);
      setCounterparties(cpRes.data || []);
      setRoutes(rRes.data || []);
      setCars(cRes.data || []);
      setDrivers(dRes.data || []);
      
      // СРАЗУ показываем ВСЕ заявки (без фильтра)
      setDisplayOrders(orders);
      console.log('📋 Показываем все', orders.length, 'заявок');
    } catch (err) {
      console.error('❌ Ошибка загрузки:', err);
      setAllOrders([]);
      setDisplayOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = (ordersToFilter) => {
    console.log('=== 🔍 ПРИМЕНЕНИЕ ФИЛЬТРОВ ===');
    console.log('  filterDateFrom:', filterDateFrom, '(тип:', typeof filterDateFrom, ')');
    console.log('  filterDateTo:', filterDateTo, '(тип:', typeof filterDateTo, ')');
    console.log('  ordersToFilter.length:', ordersToFilter?.length || 0);
    console.log('  allOrders.length:', allOrders.length);
    
    if (!ordersToFilter || ordersToFilter.length === 0) {
      console.log('  ❌ Передано 0 заявок. Используем allOrders...');
      ordersToFilter = allOrders;
      console.log('  allOrders.length:', allOrders.length);
    }
    
    if (!ordersToFilter || ordersToFilter.length === 0) {
      console.log('  ❌ Нет заявок для фильтрации');
      setDisplayOrders([]);
      return;
    }
    
    const filtered = ordersToFilter.filter(order => {
      const orderDate = order.order_date;
      let passed = true;
      let reason = '';
      
      // Если нет даты - пропускаем
      if (!orderDate) {
        return true;
      }
      
      // Фильтр ПО ДАТЕ ОТ
      if (filterDateFrom && filterDateFrom.trim() !== '') {
        const isBefore = orderDate < filterDateFrom;
        console.log(`  Заявка #${order.id}: ${orderDate} >= ${filterDateFrom} ? ${!isBefore}`);
        if (isBefore) {
          reason = `до ${filterDateFrom}`;
          passed = false;
        }
      }
      
      // Фильтр ПО ДАТЕ ДО
      if (passed && filterDateTo && filterDateTo.trim() !== '') {
        const isAfter = orderDate > filterDateTo;
        console.log(`  Заявка #${order.id}: ${orderDate} <= ${filterDateTo} ? ${!isAfter}`);
        if (isAfter) {
          reason = `после ${filterDateTo}`;
          passed = false;
        }
      }
      
      // Фильтр ПО КОНТРАГЕНТУ
      if (passed && filterCounterparty && filterCounterparty.trim() !== '') {
        if (!order.counterparty_id || order.counterparty_id !== parseInt(filterCounterparty)) {
          reason = 'другой контрагент';
          passed = false;
        }
      }
      
      // Фильтр ПО АВТО
      if (passed && filterCar && filterCar.trim() !== '') {
        if (!order.car_id || order.car_id !== parseInt(filterCar)) {
          reason = 'другое авто';
          passed = false;
        }
      }
      
      // Фильтр ПО ВОДИТЕЛЮ
      if (passed && filterDriver && filterDriver.trim() !== '') {
        if (!order.driver_id || order.driver_id !== parseInt(filterDriver)) {
          reason = 'другой водитель';
          passed = false;
        }
      }
      
      if (passed) {
        console.log(`  ✅ Заявка #${order.id} (${orderDate}) ПРОШЛА фильтр`);
      } else {
        console.log(`  ❌ Заявка #${order.id} (${orderDate}) ОТКЛОНЕНА: ${reason}`);
      }
      
      return passed;
    });
    
    console.log('📊 Результат:', filtered.length, 'из', ordersToFilter.length);
    console.log('==============================');
    setDisplayOrders(filtered);
  };

  const handleApplyFilters = () => {
    console.log('=== НАЖАТА КНОПКА "ПОКАЗАТЬ" ===');
    console.log('  allOrders.length:', allOrders.length);
    console.log('  displayOrders.length:', displayOrders.length);
    
    // Передаём allOrders явно в функцию фильтрации
    applyFilters(allOrders);
  };

  const handleResetFilters = () => {
    console.log('=== СБРОС ФИЛЬТРОВ ===');
    setFilterDateFrom('');
    setFilterDateTo('');
    setFilterCounterparty('');
    setFilterCar('');
    setFilterDriver('');
    setDisplayOrders(allOrders);
  };

  // Helper функции
  const getCounterpartyName = (id) => {
    if (!id || !counterparties.length) return '—';
    const cp = counterparties.find(c => c.id === id);
    return cp ? cp.name : '—';
  };

  const getDriverName = (id) => {
    if (!id || !drivers.length) return '—';
    const d = drivers.find(dr => dr.id === id);
    return d ? d.name : '—';
  };

  const getCarInfo = (id) => {
    if (!id || !cars.length) return '—';
    const c = cars.find(car => car.id === id);
    return c ? c.plate_number : '—';
  };

  const getRouteName = (id) => {
    if (!id || !routes.length) return '—';
    const r = routes.find(route => route.id === id);
    return r ? r.name : '—';
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить заявку #' + id + '?')) return;
    try {
      await axios.delete(`${API_URL}/orders/${id}`);
      alert('✅ Заявка удалена');
      loadData();
    } catch (err) {
      alert('Ошибка: ' + err.message);
    }
  };

  const handleEdit = (order) => {
    setSelectedOrder(order);
  };

  if (loading) {
    return <div style={{padding: '40px', textAlign: 'center', color: '#999'}}>Загрузка заявок...</div>;
  }

  return (
    <div style={styles.container}>
      {/* Панель фильтров */}
      <div style={styles.filterPanel}>
        <div style={styles.filterRow}>
          <div style={styles.filterGroup}>
            <label style={styles.label}>📅 От:</label>
            <input 
              type="date" 
              value={filterDateFrom}
              onChange={(e) => setFilterDateFrom(e.target.value)}
              style={styles.input}
            />
          </div>

          <div style={styles.filterGroup}>
            <label style={styles.label}>До:</label>
            <input 
              type="date" 
              value={filterDateTo}
              onChange={(e) => setFilterDateTo(e.target.value)}
              style={styles.input}
            />
          </div>

          <div style={styles.filterGroup}>
            <label style={styles.label}>🏢 Контрагент:</label>
            <select 
              value={filterCounterparty}
              onChange={(e) => setFilterCounterparty(e.target.value)}
              style={styles.select}
            >
              <option value="">Все</option>
              {counterparties.map(cp => (
                <option key={cp.id} value={cp.id}>{cp.name}</option>
              ))}
            </select>
          </div>

          <div style={styles.filterGroup}>
            <label style={styles.label}>🚗 Авто:</label>
            <select 
              value={filterCar}
              onChange={(e) => setFilterCar(e.target.value)}
              style={styles.select}
            >
              <option value="">Все</option>
              {cars.map(c => (
                <option key={c.id} value={c.id}>{c.plate_number}</option>
              ))}
            </select>
          </div>

          <div style={styles.filterGroup}>
            <label style={styles.label}>👨 Водитель:</label>
            <select 
              value={filterDriver}
              onChange={(e) => setFilterDriver(e.target.value)}
              style={styles.select}
            >
              <option value="">Все</option>
              {drivers.map(d => (
                <option key={d.id} value={d.id}>{d.name}</option>
              ))}
            </select>
          </div>

          <button onClick={handleApplyFilters} style={styles.btnFilter}>
            🔍 Показать
          </button>
          <button onClick={handleResetFilters} style={styles.btnReset}>
            ⟳ Сброс
          </button>
        </div>
      </div>

      {/* Таблица заявок */}
      <div style={styles.tableContainer}>
        {displayOrders.length === 0 ? (
          <div style={styles.empty}>
            <p>📭 Нет заявок</p>
            {allOrders.length > 0 && (
              <p style={{fontSize: '12px', color: '#999'}}>Всего: {allOrders.length} (примените фильтр или сбросьте)</p>
            )}
          </div>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr style={styles.headerRow}>
                <th style={styles.th}>📅 Дата</th>
                <th style={styles.th}>🎯 Точка</th>
                <th style={styles.th}>🏢 Контрагент</th>
                <th style={styles.th}>🗺️ Маршрут</th>
                <th style={styles.th}>👨 Водитель</th>
                <th style={styles.th}>🚗 Авто</th>
                <th style={styles.th}>💰 Цена</th>
                <th style={styles.th}>⚙️ Статус</th>
                <th style={styles.th}>Действия</th>
              </tr>
            </thead>
            <tbody>
              {displayOrders.map((order) => (
                <tr
                  key={order.id}
                  style={{...styles.row, cursor: 'pointer'}}
                  onClick={() => setSelectedOrder(order)}
                >
                  <td style={styles.td}>{order.order_date || '—'}</td>
                  <td style={styles.td}>{order.point_number || '—'}</td>
                  <td style={styles.td}>{getCounterpartyName(order.counterparty_id)}</td>
                  <td style={styles.td}>{getRouteName(order.route_id)}</td>
                  <td style={styles.td}>{getDriverName(order.driver_id)}</td>
                  <td style={styles.td}>{getCarInfo(order.car_id)}</td>
                  <td style={styles.td}>{order.price ? `${order.price} ₽` : '—'}</td>
                  <td style={styles.td}>
                    <span style={{color: order.status === 'new' ? '#2196F3' : '#4CAF50', fontWeight: 'bold'}}>
                      {order.status === 'new' ? '🆕' : '✅'} {order.status}
                    </span>
                  </td>
                  <td style={styles.td}>
                    <button onClick={(e) => { e.stopPropagation(); setSelectedOrder(order); }} style={styles.btnSmall} title="Открыть">👁️</button>
                    <button onClick={(e) => { e.stopPropagation(); handleEdit(order); }} style={styles.btnSmall}>✏️</button>
                    <button onClick={(e) => { e.stopPropagation(); handleDelete(order.id); }} style={styles.btnSmallDel}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Модальное окно с деталями заявки */}
      {selectedOrder && (
        <OrderDetails
          order={selectedOrder}
          onClose={() => setSelectedOrder(null)}
          onUpdated={loadData}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    background: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  filterPanel: {
    background: '#f9f9f9',
    padding: '15px',
    borderRadius: '5px',
    marginBottom: '20px',
    border: '1px solid #ddd',
  },
  filterRow: {
    display: 'flex',
    gap: '15px',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  label: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#666',
  },
  input: {
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
  },
  select: {
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    minWidth: '150px',
  },
  btnFilter: {
    padding: '8px 15px',
    background: '#075A64',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
    alignSelf: 'flex-end',
  },
  btnReset: {
    padding: '8px 15px',
    background: '#ccc',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
    alignSelf: 'flex-end',
  },
  tableContainer: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  headerRow: {
    background: '#075A64',
    color: '#fff',
  },
  th: {
    padding: '12px',
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: '13px',
  },
  row: {
    borderBottom: '1px solid #ddd',
  },
  td: {
    padding: '10px',
    fontSize: '13px',
  },
  btnSmall: {
    padding: '4px 8px',
    background: '#0C7281',
    color: '#fff',
    border: 'none',
    borderRadius: '3px',
    cursor: 'pointer',
    fontSize: '12px',
    marginRight: '5px',
  },
  btnSmallDel: {
    padding: '4px 8px',
    background: '#d32f2f',
    color: '#fff',
    border: 'none',
    borderRadius: '3px',
    cursor: 'pointer',
    fontSize: '12px',
  },
  empty: {
    textAlign: 'center',
    padding: '40px',
    color: '#999',
  },
};

export default OrdersList;
